import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import React from 'react';
import styled from 'styled-components';

interface ErrorMessageProps {
  error?: string[] | string | undefined | void;
  spaceleft?: boolean;
}

const ErrorContainer = styled.div<{ spaceleft?: boolean }>`
  display: flex;
  align-items: center;
  color: #ff0000;
  font-size: 12px;
  margin: var(--spacing-xs) 0;
  margin-left: ${({ spaceleft }) => (spaceleft ? 'var(--spacing-md)' : '0')};

  & .icon {
    margin-right: 5px;
  }
`;

function ErrorMessage({ error, spaceleft }: ErrorMessageProps) {
  if (!error || !error.length) return null;

  return (
    <ErrorContainer spaceleft={spaceleft}>
      <WarningAmberIcon /> &nbsp;
      {Array.isArray(error) ? error[0] : error}
    </ErrorContainer>
  );
}

export default ErrorMessage;
